// skio:filter:start
// Only the active subscription platform's selling plan allocations (Theme settings > Subscriptions, via window.subscriptionAppId).
function skioAllocs(variant, prod) {
    const ids = ((prod && prod.selling_plan_groups) || [])
        .filter(g => String(g.app_id) === String(window.subscriptionAppId))
        .map(g => g.id);
    return ((variant && variant.selling_plan_allocations) || [])
        .filter(a => ids.includes(a.selling_plan_group_id));
}
// skio:filter:end

(function () {

    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[data-section="${sectionID}"]`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productV22JSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productV22VariantJSON").textContent);

    // map of variant id to its maltertech.ongoing_price metafield (dollars, null when unset)
    const variantIDtoOngoingPrice = JSON.parse(section.querySelector(".productV22VariantIDtoOngoingPriceJSON").textContent);

    // map of variant id to its custom.dosage_with_text metafield, the same per dose copy the selling card shows
    const variantIDtoDose = JSON.parse(section.querySelector(".productV22VariantIDtoDoseJSON").textContent);

    // map of variant id to its maltertech.one_time_purchase_swap variant id (null when unset)
    const variantSwapMap = JSON.parse(section.querySelector(".productV22VariantSwapJSON").textContent);

    /************
     Product Swiper
     ************/

    let thumbsSwiper = new Swiper(section.querySelector(".productV22VisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 4
    });


// setup product swiper
    let productV22Swiper = new Swiper(section.querySelector(".productV22VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: section.querySelector('.productV22VisualSwiper .productV22VisualSwiperNext'),
            prevEl: section.querySelector('.productV22VisualSwiper .productV22VisualSwiperPrev'),
        },
        thumbs: {
            swiper: thumbsSwiper
        }
    });


// play video on slide play click
    section.querySelectorAll(".productV22VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV22VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV22VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

// setup Dropdowns
    section.querySelectorAll(".productV22InfoDropdownTop")?.forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     Product Variants
     ***************/

// update active variant on input changes
    section.querySelectorAll("input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })


// update active variant
    function updateProduct() {
        let sellingPlanExists = section.querySelector(".productV22Selling") || false;


        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV22OptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (activeVariant === null || activeVariant === undefined) {
            section.querySelector(".productV22ATC").disabled = true;
            section.querySelector(".productV22ATC").textContent = "not available";
            return;
        }

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV22ATC").classList.add("primary");
            section.querySelector(".productV22ATC").disabled = false;
            section.querySelector(".productV22ATC").textContent = section.querySelector(".productV22ATC").dataset.label || "add to cart";
        } else {
            section.querySelector(".productV22ATC").classList.remove("primary");
            section.querySelector(".productV22ATC").disabled = true;
            section.querySelector(".productV22ATC").textContent = "sold out";
        }

        // update payments form data
        const payInstallmentsInput = section.querySelector('.productV22PaymentsInput');
        const shopifyPaymentTerms = section.querySelector('shopify-payment-terms');
        if (payInstallmentsInput) {
            payInstallmentsInput.value = activeVariant.id;
        }
        if (shopifyPaymentTerms) {
            shopifyPaymentTerms.dataset.variantId = activeVariant.id;
            shopifyPaymentTerms.setAttribute('variant-id', activeVariant.id);
        }


        // update variant images
        section.querySelectorAll('.productV22OptionItemValuesLabelBodyWrapInnerWrap.once').forEach((element) => {
            element.classList.add("active");

        });
        section.querySelectorAll('.productV22OptionItemValuesLabelBodyWrapInnerWrap.sub').forEach((element) => {
            element.classList.remove("active");
        });
        if (section.querySelector('.productV22SellingLabelInput.sub')?.checked) {
            section.querySelectorAll('.productV22OptionItemValuesLabelBodyWrapInnerWrap.once').forEach((element) => {
                element.classList.remove("active");
            });
            section.querySelectorAll('.productV22OptionItemValuesLabelBodyWrapInnerWrap.sub').forEach((element) => {
                element.classList.add("active");
            });
        }


        // update selling plan
        updateSellingPlan(sellingPlanExists, activeVariant)


        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    /**************
     Product Selling Plan
     ***************/

    function updateSellingPlan(sellingPlanExists = true, activeVariant) {
        // Selling Plan element doesn't exist
        if (!sellingPlanExists) {
            return;
        }

        // skio:filter:start
        // was: let activeVariantPlan = activeVariant.selling_plan_allocations[0];
        let activeVariantPlan = skioAllocs(activeVariant, product)[0];
        // skio:filter:end

        // reset selcet
        let optionsHTML = "";
        // loop over every selling plan allocation for this active variant

        // skio:filter:start
        // was: activeVariant.selling_plan_allocations.forEach(sellingPlanAllocation => {
        skioAllocs(activeVariant, product).forEach(sellingPlanAllocation => {
        // skio:filter:end
            // find the selling plan name since it's not in the object
            let sellingPlan = getSellingPlanById(sellingPlanAllocation.selling_plan_id);

            // create an option for the select
            // manual check for the starter kit selling plan
            if (sellingPlanAllocation.selling_plan_group_id !== "91e7beddcc2b25a88da97e3b201deec8db7b43bb") {
                optionsHTML += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
            }
        });
        section.querySelectorAll(".productV22SellingLabelBodyBottomWrapContentSelect").forEach((select) => {
            select.innerHTML = optionsHTML;
        })


        // update text
        let save = (1 - (activeVariantPlan.price / activeVariant.price)) * 100;

        // save parent elements
        const once = section.querySelector(".productV22SellingLabelBody.once");
        const sub = section.querySelector(".productV22SellingLabelBody.sub");

        // update compare at price for one time and sub
        if (activeVariant.compare_at_price > activeVariant.price) {
            once.querySelector(".productV22SellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
        } else {
            once.querySelector(".productV22SellingLabelBodyPriceCompare").textContent = "";
        }

        sub.querySelector(".productV22SellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
        if (activeVariantPlan.compare_at_price > activeVariant.compare_at_price) {
            sub.querySelector(".productV22SellingLabelBodyPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity, true);
        }

        // update actual price
        once.querySelector(".productV22SellingLabelBodyPriceReal").textContent = price(activeVariant.price * quantity, true);
        sub.querySelector(".productV22SellingLabelBodyPriceReal").textContent = price(activeVariantPlan.price * quantity, true);

        once.querySelector(".productV22SellingLabelBodyPriceReal").classList.remove("sale");

        if (activeVariant.compare_at_price > activeVariant.price) {
            once.querySelector(".productV22SellingLabelBodyPriceReal").classList.add("sale");
        }

        // update save text
        // if one time, save $15, else save $30
        // the badge is only active when a variant has a compare at price, so it can be missing
        const saveBadge = section.querySelector('.productV22OptionItemValuesLabelBodyWrapSave.active');
        if (saveBadge && section.querySelector('.productV22SellingLabelInput:checked').value === "sub") {
            saveBadge.textContent = `Save $46`;
        } else if (saveBadge) {
            saveBadge.textContent = `Save $15`;
        }


        // // update one time text
        // once.querySelector(".productV22SellingLabelBodyBottomWrapContentTxt").textContent = ``;
        // if (section.querySelector('.productV22SellingLabelInput:checked').value === "once") {
        if (product.handle === "brainstorm-journal") {
            once.querySelector(".productV22SellingLabelBodyBottomWrapContentTxt").innerHTML = `<strong>DOES NOT INCLUDE</strong> THE ILLUSTRATED PLANNER OR FREE SHIPPING`;
        } else if (product.handle === "happy-ending-x-dipsea") {
            once.querySelector(".productV22SellingLabelBodyBottomWrapContentTxt").innerHTML = `<strong>DOES NOT INCLUDE</strong> FREE SHIPPING, EXTRA 15% OFF, OR FREE SUBSCRIPTION TO DIPSEA AUDIOBOOKS`;
        } else {
            once.querySelector(".productV22SellingLabelBodyBottomWrapContentTxt").innerHTML = `<strong>DOES NOT INCLUDE</strong> NIGHTCAP STARTER KIT, FREE SHIPPING, SLEEP DIGITAL PLAYBOOK OR GUIDED SLEEP MEDITATIONS`;

        }
        // }

        // update one time bullets
        if (section.querySelector('.productV22OptionItemValuesLabelInput:checked').value === "4" && section.querySelector('.productV22SellingLabelInput:checked').value === "once") {
            once.querySelector(".productV22SellingLabelBodyBottomWrapContentBullets.once")?.classList.add("active");
        }

        section.querySelectorAll('.productV22SellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
            element.classList.remove("active");
        });
        if (section.querySelector('.productV22SellingLabelInput:checked').value === "sub") {
            section.querySelectorAll('.productV22SellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
                element.classList.add("active");
            });
        }

        // update 4 tins icons
        if (section.querySelector('.productV22OptionItemValuesLabelInput:checked').value === "4") {
            section.querySelectorAll('.productV22SellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
                element.classList.add("active");
            });

            section.querySelectorAll('.productV22SellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
                element.classList.remove("active");
            });
        }

        // update 2 tins icons
        if (section.querySelector('.productV22OptionItemValuesLabelInput:checked').value === "2") {
            section.querySelectorAll('.productV22SellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
                element.classList.add("active");
            });

            section.querySelectorAll('.productV22SellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
                element.classList.remove("active");
            });
        }

        section.dispatchEvent(new CustomEvent('mainProduct:update'))

    }


    /****************
     * Product Quantity
     */

    let quantity = 1;
    updateProduct();


    /**************
     Product ATC
     ***************/

    async function addToCart(button) {
        // add loading animation
        button.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (section.querySelector('.productV22SellingLabelInput.sub')?.checked) {
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: let activeVariantPlan = activeVariant.selling_plan_allocations[0];
            let activeVariantPlan = skioAllocs(activeVariant, product)[0];
            // skio:filter:end
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: for (let plan of activeVariant.selling_plan_allocations) {
            for (let plan of skioAllocs(activeVariant, product)) {
            // skio:filter:end
                if (plan.selling_plan_id === parseInt(section.querySelector('.productV22SellingLabelBodyBottomWrapContentSelect').value)) {
                    activeVariantPlan = plan;
                }
            }
            formData.items[0].selling_plan = activeVariantPlan.selling_plan_id
        } else {
            if (variantSwapMap[activeVariant.id]) {
                // one-time purchase swaps to the variant set in the metafield
                formData.items[0].id = variantSwapMap[activeVariant.id];
            } else if (product.handle === "nightcap-starter-kit") {
                // map back to original variants for one-time since they don't get the starter kit
                formData.items[0].id = activeVariant.id === 43225179062409 ? 40815844589705 : 40815844622473
            } else if (product.handle === "brainstorm-journal") {
                formData.items[0].id = activeVariant.id === 43278816968841 ? 40815834464393 : 40815834497161
            } else if (product.handle === "happy-ending-x-dipsea") {
                formData.items[0].id = activeVariant.id === 43316629635209 ? 41711203844233 : 41711203877001
            }

        }

        // add product
        await addProduct(formData);

        // remove loading animation
        button.classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector(".productV22ATC").addEventListener("click", function () {
        addToCart(this);
    });


    /**************
     Product Sticky Bar (Mobile)
     ***************/

    // the sticky bar renders outside the section element, so match it on this section's id (both AB arms are in the DOM)
    const productV22Sticky = document.querySelector(`.productV22Sticky[data-product-sticky="${sectionID}"]`);
    if (productV22Sticky) {
        const productV22ATCEl = section.querySelector(".productV22ATC");
        const productV22StickySubInput = productV22Sticky.querySelector('.productV22StickyTopLeftBodyOptionsLabelInput[value="sub"]');
        const productV22StickyDose = productV22Sticky.querySelector(".productV22StickyBottomDose");
        const productV22StickyPrice = productV22Sticky.querySelector(".productV22StickyBottomPrice");
        const productV22StickyATC = productV22Sticky.querySelector(".productV22StickyTopATC");

        // several product sections can share a page, only the first bar whose section is rendered may show
        function ownsSticky() {
            const owner = [...document.querySelectorAll("[data-product-sticky]")].find(bar => {
                const barSection = document.querySelector(`[data-section="${bar.dataset.productSticky}"], [id="${bar.dataset.productSticky}"]`);
                return barSection && barSection.offsetParent !== null;
            });
            return owner != null && owner.dataset.productSticky === sectionID;
        }

        // show the sticky bar whenever the main ATC isn't in the viewport (above or below)
        function toggleStickyVisibility() {
            const rect = productV22ATCEl.getBoundingClientRect();
            const inView = rect.bottom > 0 && rect.top < window.innerHeight;
            productV22Sticky.classList.toggle("visible", !inView && ownsSticky());
        }

        window.addEventListener("scroll", toggleStickyVisibility, {passive: true});
        toggleStickyVisibility();

        // sync the sticky bar choice into the main selling radio so the rest of the page updates
        productV22Sticky.querySelectorAll(".productV22StickyTopLeftBodyOptionsLabelInput").forEach(input => {
            input.addEventListener("change", function () {
                const mainInput = section.querySelector(`.productV22SellingLabelInput.${this.value}`);
                if (mainInput) {
                    mainInput.checked = true;
                    mainInput.dispatchEvent(new Event("change", {bubbles: true}));
                }
            });
        });

        // sticky ATC reuses the same add-to-cart flow
        productV22StickyATC.addEventListener("click", function () {
            addToCart(this);
        });

        // refresh dose visibility and price text from current variant + selling state
        function updateProductSticky() {
            const subChecked = productV22StickySubInput.checked;

            // dose price comes from the active variant's dosage metafield, hidden when it has no price
            const dosePrice = (variantIDtoDose[activeVariant.id] || "").match(/\$\d+(\.\d+)?/);
            productV22StickyDose.textContent = dosePrice ? `${dosePrice[0]}/dose` : "";

            // dose only shows for subscription
            productV22StickyDose.classList.toggle("active", subChecked && dosePrice != null);

            // price text differs by selling type
            if (subChecked) {
                // skio:filter:start
                // was: const subPrice = price(activeVariant.selling_plan_allocations[0].price * quantity, true);
                const subPrice = price(skioAllocs(activeVariant, product)[0].price * quantity, true);
                // skio:filter:end

                // ongoing price comes from the variant's maltertech.ongoing_price metafield, fall back to the selling plan price
                // skio:filter:start
                // was: let ongoingPrice = activeVariant.selling_plan_allocations[0].price;
                let ongoingPrice = skioAllocs(activeVariant, product)[0].price;
                // skio:filter:end
                const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
                if (ongoingPriceMetafield != null) {
                    ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
                }

                productV22StickyPrice.innerHTML = `<strong>${subPrice} </strong>+ FREE shipping* - <em>${price(ongoingPrice, true)}/mo after, cancel anytime</em>`;
            } else {
                const oncePrice = price(activeVariant.price * quantity, true);
                productV22StickyPrice.innerHTML = `<strong>${oncePrice}</strong> + $9.99 shipping*`;
            }
        }

        // re-render whenever the main product update event fires
        section.addEventListener("mainProduct:update", updateProductSticky);
        updateProductSticky();
    }


    /**
     * Given a selling plan id, find the master selling plan object
     * @param {number} sellingPlanId
     * @returns {Object}
     */
    function getSellingPlanById(sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
                if (plan.id === sellingPlanId) {
                    sellingPlan = plan;
                }
            });
        });
        return sellingPlan;
    }


// font fix override for shopify payments (make b element normal weight)
    document.addEventListener("DOMContentLoaded", async function () {
        customElements.whenDefined("shopify-payment-terms").then(() => {
            customElements.whenDefined("shop-pay-installments-banner").then(() => {
                // the element is absent on products without installments, so bail out rather than throw
                const bannerBold = section.querySelector("shopify-payment-terms")?.shadowRoot?.querySelector("shop-pay-installments-banner")?.shadowRoot?.querySelector("b");
                if (!bannerBold) {
                    return;
                }
                bannerBold.style = "font-weight: 400;";
            });
        });
    });


    /************
     Selling UI (folded from shared product-main.js + product-js.js, section-scoped)
     ************/

    // initialize the custom selling-plan select dropdown
    function initializeCustomSelect() {
        const selectElement = section.querySelector(".productV22SellingLabelBodyBottomWrapContentSelect");
        const detailsElement = section.querySelector(".customDetails");
        if (!selectElement || !detailsElement) {
            return;
        }

        const summaryElement = detailsElement.querySelector(".customDetailsTitle");
        const optionElements = detailsElement.querySelectorAll(".customOption");

        // sync the visible summary to the native select's current value
        const initialOption = selectElement.options[selectElement.selectedIndex];
        const initialValue = initialOption ? initialOption.value : "";
        if (summaryElement) {
            summaryElement.firstElementChild.textContent = initialOption ? initialOption.textContent : "";
        }

        optionElements.forEach((option, index) => {
            const value = selectElement.options[index]?.value || "";
            option.setAttribute("data-value", value);
            option.classList.toggle("selected", value === initialValue);
        });

        // clicking a custom option writes back to the native select
        optionElements.forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.dataset.value;
                const text = option.textContent.trim();
                selectElement.value = value;
                if (summaryElement) {
                    summaryElement.firstElementChild.textContent = text;
                }
                optionElements.forEach((opt) => opt.classList.remove("selected"));
                option.classList.add("selected");
                detailsElement.removeAttribute("open");
            });
        });
    }

    // refresh the SAVE badges from the active variant pricing
    function updateSavingsDisplay() {
        if (!activeVariant) {
            return;
        }
        const subSaveElement = section.querySelector(".productV22SellingTagDiscountSub");
        const oneTimeSaveElement = section.querySelector(".productV22SellingTagDiscountOne");
        if (!subSaveElement) {
            return;
        }
        // skio:filter:start
        // was: const sellingPlanPrice = activeVariant.selling_plan_allocations?.[0]?.price;
        const sellingPlanPrice = skioAllocs(activeVariant, product)?.[0]?.price;
        // skio:filter:end
        if (sellingPlanPrice === undefined) {
            return;
        }
        const subTotal = activeVariant.compare_at_price ? activeVariant.compare_at_price - sellingPlanPrice : activeVariant.price - sellingPlanPrice;
        const oneTimeTotal = activeVariant.compare_at_price - activeVariant.price;
        subSaveElement.innerHTML = `SAVE ${price(subTotal, true)}`;
        if (oneTimeSaveElement) {
            if (oneTimeTotal > 0) {
                oneTimeSaveElement.innerHTML = `SAVE ${price(oneTimeTotal, true)}`;
                oneTimeSaveElement.classList.remove("hidden");
            } else {
                oneTimeSaveElement.classList.add("hidden");
            }
        }

        // discount percentage off the base price (compare-at when present, otherwise regular price)
        const basePrice = activeVariant.compare_at_price || activeVariant.price;
        const discountPercent = Math.round((basePrice - sellingPlanPrice) / basePrice * 100);

        // ongoing price comes from the variant's maltertech.ongoing_price metafield (dollars), fall back to the selling plan price
        let ongoingPrice = sellingPlanPrice;
        const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
        if (ongoingPriceMetafield != null) {
            ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
        }
        const ongoingPercent = Math.round((basePrice - ongoingPrice) / basePrice * 100);

        // update bullet price — ongoing price per month plus the ongoing discount percentage
        const bulletSaveElement = section.querySelector(".productV22SellingLabelBodyBottomWrapContentBulletsItemSave");
        if (bulletSaveElement) {
            bulletSaveElement.innerHTML = `
                <span class="productV22SellingLabelBodyBottomWrapContentBulletsItemSavePrice">${price(ongoingPrice, true)}/mo after first order</span>
                <span class="productV22SellingLabelBodyBottomWrapContentBulletsItemSaveOngoing">(${ongoingPercent}% OFF ongoing)</span>
            `;
        }
    }

    // hide the one-time bottom block when it has no text
    function checkOneTimeTextVisibility() {
        const textElement = section.querySelector(".productV22SellingLabelBodyBottomWrapContentTxt");
        const bottomContentElement = section.querySelector(".productV22SellingLabelBody.once .productV22SellingLabelBodyBottom");
        if (!textElement || !bottomContentElement) {
            return;
        }
        bottomContentElement.classList.toggle("hidden", textElement.textContent.trim() === "");
    }

    // swap dosage text when a dosage option is clicked
    section.querySelectorAll("[data-dosage-click]").forEach((dosageOption) => {
        dosageOption.addEventListener("click", function () {
            const subItem = section.querySelector(".productV22SellingLabelBodyTopLeftDosageText");
            const oneTimeItem = section.querySelector(".productV22SellingLabelBodyTopLeftDosageText.oneTime");
            if (subItem) {
                subItem.innerHTML = dosageOption.getAttribute("data-dosage-sub");
            }
            if (oneTimeItem) {
                oneTimeItem.innerHTML = dosageOption.getAttribute("data-dosage-one-time");
            }
        });
    });

    // re-run the selling UI on load and on every product update
    function refreshSellingUI() {
        initializeCustomSelect();
        updateSavingsDisplay();
        checkOneTimeTextVisibility();
    }

    section.addEventListener("mainProduct:update", refreshSellingUI);
    refreshSellingUI();


    /************
     Anchor Links
     ************/

    // several product sections can share a page (both AB arms are in the DOM), only the first rendered one answers
    function ownsAnchors() {
        const owner = [...document.querySelectorAll(".productV22[data-section]")].find(productSection => {
            return productSection.offsetParent !== null;
        });
        return owner != null && owner.dataset.section === sectionID;
    }

    // links to #product scroll to this section rather than jumping to a hash that doesn't exist
    document.querySelectorAll('a[href="#product"]').forEach((link) => {
        link.addEventListener("click", function (event) {
            if (!ownsAnchors()) {
                return;
            }
            event.preventDefault();
            section.scrollIntoView({behavior: "smooth", block: "start"});
        });
    });


}());